export { SamFloatingTile, type SamFloatingTileProps } from "./SamFloatingTile"
